import React, { useState, useEffect } from 'react';
import {
  DownOutlined
} from '@ant-design/icons';

import {
  Tree,
} from 'antd';
import './styles.scss';
import { ReactComponent as PastaFechadaSvg } from '../../../assets/icons/pastaFechadaMenu.svg';
import { ReactComponent as PastaSvg } from '../../../assets/icons/pasta-menu.svg';
import { ReactComponent as PastaFechadaSvgSelecionado } from '../../../assets/icons/pastaFechadaMenuSelecionado.svg';
import { ReactComponent as PastaSvgSelecionado } from '../../../assets/icons/pasta-menu-selecionado.svg';
const ArvorePasta = ({ pastaSelecionada,
  expandedKeys,
  searchValue,
  expanded,
  setExpandedKeyss,
  autoExpandParent,
  setAutoExpandParent,
  treeData,
  loadData,
  expadendAll,
  showTreeData }) => {
    
  const { DirectoryTree } = Tree;


  const loop = data =>
  data.map(item => {
      const index = item.title.indexOf(searchValue);
      const beforeStr = item.title.substr(0, index);
      const afterStr = item.title.substr(index + searchValue.length);
      const title =
          index > -1 ? (
              <span>
                  {beforeStr}
                  <span className="site-tree-search-value">{searchValue}</span>
                  {afterStr}
              </span>
          ) : (
              <span>{item.title}</span>
          );
      if (item.children) {
          return { title, key: item.key, children: loop(item.children) };
      }
      return {
          title,
          key: item.key,
      };
  });

  const onExpand = expandedKeys => {
    setExpandedKeyss(expandedKeys);
    setAutoExpandParent(false);
  };
  const renderizarIcone = (props) => {
    const { isLeaf, expanded, selected } = props;
  
    let iconeAberto = <PastaFechadaSvg />;
    let iconeFechado = <PastaSvg />;
  
    if (selected) {
      iconeAberto = <PastaFechadaSvgSelecionado />;
      iconeFechado = <PastaSvgSelecionado />;
    }
  
    const icone = isLeaf ? null : expanded ? iconeAberto : iconeFechado;
  
    return icone;
  };
  
  return (
    <div>   
    {showTreeData && (
  <div className="teeeste">
    <DirectoryTree
      onSelect={pastaSelecionada}
      defaultExpandAll={expadendAll}
      className='lista-pastas'
      loadData={loadData}
      treeData={treeData}
      onExpand={expanded}
      switcherIcon={<DownOutlined />}
      icon={renderizarIcone}
      multiple
    />
  </div>
)}

    </div>
  )
}

export default ArvorePasta;